export { default } from '@capitalx/web-ui-shared-components/lib/components/atoms/button';
